const project1 = () => {
    return (
      <div>
        <h1>Project 1: Hospital administration Project</h1>
        <p>This project was developed on Java Netbeans using Swing API  and MSSQL as DBMS connected with JDBC for storing data.</p>
      </div>
    );
  };
  
  export default project1;
  